import apiConfig from "~/shared/config/api";
import useMainStore from "~/shared/store";
import useCartStore from "~/shared/store/modules/cart";
import customFetch from "~/composables/custom-fetch";
import useAccountStore from "~/shared/store/modules/account";
import useCompaniesStore from "~/shared/store/modules/account/companies";
import useOrderStore from "~/shared/store/modules/order";
import getInitialData from "~/composables/initial-data";

async function logout() {
  const { auth } = apiConfig
  const res = await customFetch(auth.logout())

  if (res.success) {
    // useCookie('token').value = null
    useCookie('user').value = null
    useMainStore().$reset();
    useCartStore().$reset();
    useAccountStore().$reset();
    useCompaniesStore().$reset();
    useOrderStore().$reset();
    localStorage.clear();
    await getInitialData()
    navigateTo(useRoute().name === 'cart' ? '/cart' : '/')
  }
}

export default logout
